import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const CANCELLED = "Payment not completed — your pledge is unchanged.";

export const TestFunding = ({ p, onChange }) => {
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState(null);
  const polled = useRef(false);
  const approved = p.ownerStatus?.startsWith("Approved by owner");
  const mine = p.support.mine;

  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    const sid = q.get("fund_session");
    const clean = () => window.history.replaceState({}, "", window.location.pathname);
    if (q.get("fund") === "cancelled") { setNote(CANCELLED); clean(); return; }
    if (!sid || polled.current) return;
    polled.current = true;
    setBusy(true);
    const poll = async (n) => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.paymentStatus === "paid") { toast("Test-mode payment confirmed — no real money moved"); clean(); setBusy(false); return api.get(`/proposals/${p.id}`).then((r) => onChange(r.data)); }
        if (data.status === "expired" || n >= 8) { setNote(CANCELLED); clean(); return setBusy(false); }
      } catch { setNote(CANCELLED); clean(); return setBusy(false); }
      setTimeout(() => poll(n + 1), 2000);
    };
    poll(0);
  }, [onChange, p.id]);

  const start = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/proposals/${p.id}/fund/checkout`, { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) { toast(errMsg(e, CANCELLED)); setBusy(false); }
  };

  return (
    <div className="mt-5 border-t border-white/15 pt-4" data-testid="test-funding">
      <p className="text-sm font-semibold text-[var(--bone)]/90" data-testid="test-funds-label">{p.testFunds.label}</p>
      <p className="text-xs text-[var(--bone)]/55">Applies to {p.testFunds.appliesTo.toLowerCase()} only. Kept separate from conditional support and real funds.</p>
      {approved && mine && !mine.testFulfilled && (
        <div className="mt-3">
          <button className="btn-primary !bg-[var(--bone)] !text-[var(--charcoal)] hover:!bg-white" disabled={busy} onClick={start} data-testid="fulfill-pledge-test-button">
            {busy && <Loader2 size={15} className="animate-spin" />} Fulfill pledge (test mode)
          </button>
          <p className="mt-2 text-xs text-[var(--bone)]/70" data-testid="test-card-hint">Test mode: use card 4242 4242 4242 4242</p>
        </div>
      )}
      {mine?.testFulfilled && <p className="mt-2 text-xs text-[var(--bone)]/80" data-testid="pledge-fulfilled-test">Your pledge is fulfilled (test mode).</p>}
      {busy && !note && polledMsg(polled.current)}
      {note && <p className="mt-2 text-sm text-[#F7C4BD]" data-testid="payment-not-completed">{note}</p>}
    </div>
  );
};

const polledMsg = (on) => (on ? <p className="mt-2 flex items-center gap-2 text-xs text-[var(--bone)]/70" data-testid="payment-confirming"><Loader2 size={13} className="animate-spin" /> Confirming your test-mode payment…</p> : null);
